import {
  getUserEmail,
  getUserFullName,
} from "@faire/help-center-utils/serialized-data/getUser";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as EmailQueryParameters } from "@faire/web-api--source/routes/support/self-serve/email";

import { IEmailUsFormValues } from "../view/Email/utils";

import { useIssuePlaceholder } from "./useIssuePlaceholder";
import { useScrollToTopOnLoadEffect } from "./useScrollToTopEffect";
import { useSelectedOrderNumber } from "./useSelectedOrderNumber";

export const useInitializeEmailField = () => {
  const userFullName = getUserFullName();
  const emailAddress = getUserEmail();
  const queryParams = useQueryParams(EmailQueryParameters.parse);
  const selectedOrderNumber = useSelectedOrderNumber();
  const issuePlaceholder = useIssuePlaceholder();

  useScrollToTopOnLoadEffect(10);
  const { strictLocalize } = useStrictLocalization();
  const prefilledDescriptionMessage =
    strictLocalize({
      defaultMessage: "'{Pre-populated message}",
      description: {
        text: "Indicates that this message is a pre-populated message and can be edited",
      },
    }) +
    "\n" +
    strictLocalize({
      defaultMessage:
        "My marketing tools and referral invites were suspended—can I restore access?",
    });
  const prefilledSubjectLineMessage = strictLocalize({
    defaultMessage: "Regaining access to marketing tools",
    description: {
      text: "Subject line of the request form, indicates the user needs help to regain their marketing tool access",
    },
  });

  const emailUsInitial: IEmailUsFormValues = {
    name: userFullName,
    email: emailAddress,
    subject:
      queryParams.contact_reason === "invites_suspended"
        ? prefilledSubjectLineMessage
        : issuePlaceholder,
    orderNumber: selectedOrderNumber,
    description:
      queryParams.contact_reason === "invites_suspended"
        ? prefilledDescriptionMessage
        : "",
    websiteUrl: "",
  };
  return { emailUsInitial };
};
